<template>
  <section>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img
        src="img/avatars/profile.png"
        class="img-avatar"
        alt="admin@bootstrapmaster.com" />
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong><br><span>{{ (user.name != null ? user.name: '') }}</span></b-dropdown-header>
        <b-dropdown-item @click="redirectTo('/changePassword')" style="font-size:smaller"><i class="fa fa-key" /> Change Password</b-dropdown-item>
        <b-dropdown-item @click="logMeOut" style="font-size:smaller"><i class="fa fa-lock" /> Logout</b-dropdown-item>
      <b-dropdown-header tag="div" class="text-center" v-if="checkClaim(CAN_MANAGE_USERS) || checkClaim(CAN_MANAGE_ROLES) || checkClaim(CAN_MANAGE_SETTINGS)">
          <strong>Administration</strong>
      </b-dropdown-header>
      <b-dropdown-item @click="redirectTo('/users')" v-if="checkClaim(CAN_MANAGE_USERS)" style="font-size:smaller"><i class="fa fa-user" /> Users Management</b-dropdown-item>
      <b-dropdown-item @click="redirectTo('/admin/lookup-management')" v-if="checkClaim(CAN_MANAGE_SETTINGS)" style="font-size: smaller"><i class="fa fa-list-alt" /> Lookup Management</b-dropdown-item>
      <b-dropdown-item @click="redirectTo('/settings')" v-if="checkClaim(CAN_MANAGE_SETTINGS)" style="font-size:smaller"><i class="fa fa-wrench" /> Settings</b-dropdown-item>
      <b-dropdown-item @click="redirectTo('/quickbooks')" v-if="checkClaim(CAN_MANAGE_SETTINGS)" style="font-size:smaller"><i class="fa fa-file" /> Quickbooks</b-dropdown-item>
      <!-- <b-dropdown-item v-if="$route.name=='Dashboard'" v-b-modal.widget-setting-modal style="font-size:smaller"><i class="fa fa-gears" /> Widget Settings</b-dropdown-item>
      <b-dropdown-item v-if="$route.name=='Dashboard'" @click="$refs.testes.saveLayout()" style="font-size:smaller"><i class="fa fa-refresh" /> Reset Widget Settings</b-dropdown-item> -->
    </template>
  </AppHeaderDropdown>
  <WidgetSetting v-if="$route.name=='Dashboard'" ref="testes" />
  </section>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { mapState, mapActions } from 'vuex'
import { router } from '@/router'
//import { userService } from "@/resources/UserService.js";
import WidgetSetting from '@/pages/Dashboard/components/WidgetSetting'
export default {
  name: 'DefaultHeaderDropdown',
  components: {
    AppHeaderDropdown,
    WidgetSetting
  },
  computed: {
    ...mapState('account', ['user'])
  },
  methods: {
    ...mapActions('account', ['logout']),
    logMeOut() {
      this.logout();
    },
    redirectTo(link) {
      router.push(link);
    }
  },
  created() {
    //console.log(this.user.username);
  }

}
</script>

<style>
.dropdown-item{
  min-width: 155px !important;
}
</style>
